/*
 * @Author: 孙培国
 * @Date: 2022-10-12 17:48:36
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-04-13 16:10:33
 * @FilePath: \dataplaform\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as echarts from 'echarts'
import '@/permission.js'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/utils/detectZoom.js'
// 引入TUI
import Tui from '@wocwin/t-ui'
// 引入iconfont
import './assets/fonts/iconfont.css'

Vue.use(Tui)
Vue.prototype.$echarts = echarts

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
